import { createAction, props } from '@ngrx/store';

export enum InvoiceSummaryActionTypes {
  Init = '[InvoiceSummary Page] Init',
  ViewPoliciesClicked = '[InvoiceSummary Page] View Policies Clicked',
}

export const InvoiceSummaryActions = {
  init: createAction(InvoiceSummaryActionTypes.Init),
  viewPoliciesClicked: createAction(
    InvoiceSummaryActionTypes.ViewPoliciesClicked
  ),
};
